import { render, staticRenderFns } from "./JsonDisplay.vue?vue&type=template&id=1e2822b4&lang=pug"
import script from "./JsonDisplay.vue?vue&type=script&lang=js"
export * from "./JsonDisplay.vue?vue&type=script&lang=js"
import style0 from "./JsonDisplay.vue?vue&type=style&index=0&id=1e2822b4&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports